import { render, staticRenderFns } from "./LandPopularPush.vue?vue&type=template&id=8035d848&scoped=true"
import script from "./LandPopularPush.vue?vue&type=script&lang=js"
export * from "./LandPopularPush.vue?vue&type=script&lang=js"
import style0 from "./LandPopularPush.vue?vue&type=style&index=0&id=8035d848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8035d848",
  null
  
)

export default component.exports